export const DIVIDER_HEIGHT = 1;
export const MEDIUM_DIVIDER_MARGIN = 4;
export const X_LARGE_DIVIDER_MARGIN = 8;

export const MEDIUM_AUTOCOMPLETE_OPTION_HEIGHT = 24;
export const MEDIUM_AUTOCOMPLETE_LISTBOX_PADDING = 8;

export const X_LARGE_AUTOCOMPLETE_OPTION_HEIGHT = 28;
export const X_LARGE_AUTOCOMPLETE_LISTBOX_PADDING = 16;
